import * as React from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SortOrder } from './types';

interface SortHeaderProps {
  label: string;
  field: string;
  activeField: string | null;
  activeOrder: SortOrder;
  onSort: (field: string) => void;
  className?: string;
}

/**
 * Clickable column header that drives the shared table sort. Only the actively
 * sorted column shows a direction arrow; there's no always-on sort icon.
 */
const SortHeader: React.FC<SortHeaderProps> = ({
  label,
  field,
  activeField,
  activeOrder,
  onSort,
  className,
}) => {
  const active = activeField === field;
  const DirIcon = activeOrder === 'asc' ? ArrowUp : ArrowDown;

  return (
    <button
      type="button"
      onClick={() => onSort(field)}
      className={cn(
        'flex items-center gap-1 -ml-1 px-1 py-1 rounded hover:text-foreground transition-colors',
        active ? 'text-foreground font-medium' : 'text-muted-foreground',
        className,
      )}
    >
      {label}
      {active ? <DirIcon className="h-3.5 w-3.5" /> : null}
    </button>
  );
};

export default SortHeader;
